import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, ArrowRight, ShieldCheck, Clock } from 'lucide-react';
export function Pricing() {
  const standardIncludes = ['Acces la toate cele 9 module video, pas cu pas, pe platformă privată', 'Materiale de lucru și exerciții practice pentru fiecare modul', 'Un workshop live de grup o dată pe lună, ghidat de mine', 'Acces la comunitatea privată a participantelor', 'Ghidare pe toată durata celor 9 luni'];
  const vipIncludes = ['O sesiune lunară de grup pentru aprofundare și punere în practică', '2 sesiuni individuale 1:1 cu mine, pe durata programului', 'Suport VIP pe WhatsApp în privat'];
  return <section className="py-20 md:py-28 bg-ivory overflow-hidden" id="aplica" data-id="element-678">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-679">
        <div className="text-center max-w-[800px] mx-auto mb-16" data-id="element-680">
          <FadeIn data-id="element-681">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6" data-id="element-682">
              Cele două pachete disponibile și ce include fiecare
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-[1000px] mx-auto mb-16" data-id="element-683">
          {/* Standard Package */}
          <FadeIn data-id="element-684">
            <div className="bg-white border border-gold/30 rounded-[32px] p-8 md:p-10 shadow-soft h-full flex flex-col relative overflow-hidden" data-id="element-685">
              <div className="absolute top-0 right-0 w-48 h-48 bg-gold/5 rounded-full blur-2xl -z-10" data-id="element-686"></div>

              <h3 className="text-2xl font-serif font-medium text-forest mb-6" data-id="element-687">
                PACHETUL STANDARD
              </h3>

              <div className="mb-8" data-id="element-688">
                <p className="text-sm font-display font-medium text-charcoal/60 uppercase tracking-wider mb-4" data-id="element-689">
                  Ce e inclus:
                </p>
                <ul className="space-y-4" data-id="element-690">
                  {standardIncludes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-691">
                      <Check className="w-5 h-5 text-gold-dark shrink-0 mt-0.5" data-id="element-692" />
                      <span className="text-[18px] text-charcoal/80" data-id="element-693">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-auto pt-8 border-t border-gold/20" data-id="element-694">
                <div className="mb-6" data-id="element-695">
                  <p className="text-3xl font-serif font-medium text-forest mb-1" data-id="element-696">
                    495 lei{' '}
                    <span className="text-lg font-sans text-charcoal/60 font-normal" data-id="element-697">
                      / lună (9 luni)
                    </span>
                  </p>
                  <p className="text-sm text-charcoal/60" data-id="element-698">total 4.455 lei</p>
                  <p className="mt-2 text-forest font-medium" data-id="element-699">
                    Sau 3.524 lei plată integrală
                  </p>
                </div>

                <a href="https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201." target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center px-6 py-4 rounded-full bg-forest text-ivory font-display text-lg font-medium hover:bg-forest-light transition-colors no-underline gap-2 group" data-id="element-700">
                  Aplică pentru Pachetul Standard
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-701" />
                </a>
              </div>
            </div>
          </FadeIn>

          {/* VIP Package */}
          <FadeIn delay={0.1} data-id="element-702">
            <div className="bg-forest border border-forest-light rounded-[32px] p-8 md:p-10 shadow-xl h-full flex flex-col relative overflow-hidden" data-id="element-703">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -z-10" data-id="element-704"></div>

              <div className="inline-block border border-gold/40 rounded-full px-4 py-1 mb-4 bg-gold/10 self-start" data-id="element-705">
                <span className="font-display text-xs font-semibold tracking-wider text-gold uppercase" data-id="element-706">
                  Recomandat
                </span>
              </div>

              <h3 className="text-2xl font-serif font-medium text-ivory mb-6" data-id="element-707">
                PACHETUL VIP
              </h3>

              <div className="mb-8" data-id="element-708">
                <p className="text-sm font-display font-medium text-ivory/60 uppercase tracking-wider mb-4" data-id="element-709">
                  Tot ce e în Standard plus:
                </p>
                <ul className="space-y-4" data-id="element-710">
                  {vipIncludes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-711">
                      <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-712" />
                      <span className="text-[18px] text-ivory/90" data-id="element-713">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-auto pt-8 border-t border-ivory/10" data-id="element-714">
                <div className="mb-6" data-id="element-715">
                  <p className="text-3xl font-serif font-medium text-ivory mb-1" data-id="element-716">
                    635 lei{' '}
                    <span className="text-lg font-sans text-ivory/60 font-normal" data-id="element-717">
                      / lună (9 luni)
                    </span>
                  </p>
                  <p className="text-sm text-ivory/60" data-id="element-718">total 5.715 lei</p>
                  <p className="mt-2 text-gold font-medium" data-id="element-719">
                    Sau 4.524 lei plată integrală
                  </p>
                  <p className="text-sm text-ivory/70 mt-1" data-id="element-720">
                    + o Ședință extra de Coaching 1 la 1 în valoare de 500 lei
                  </p>
                </div>

                <a href="https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201." target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center px-6 py-4 rounded-full bg-ivory text-forest font-display text-lg font-medium hover:bg-white transition-colors no-underline gap-2 group" data-id="element-721">
                  Aplică pentru Pachetul VIP
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-722" />
                </a>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Guarantee and Urgency */}
        <div className="max-w-[800px] mx-auto space-y-6" data-id="element-723">
          <FadeIn delay={0.2} data-id="element-724">
            <div className="bg-white border border-gold/20 rounded-[20px] p-6 flex items-start gap-4 shadow-sm" data-id="element-725">
              <ShieldCheck className="w-8 h-8 text-forest shrink-0" data-id="element-726" />
              <div data-id="element-727">
                <h4 className="font-medium text-forest mb-1" data-id="element-728">Garanție:</h4>
                <p className="text-charcoal/70 text-[18px] leading-relaxed" data-id="element-729">
                  Lucrez cu grupuri restrânse și potrivite. Dacă, după începutul
                  programului, simți că nu este ceea ce ai nevoie, putem opri
                  colaborarea în primele etape și primești rambursarea pentru
                  perioada rămasă, fără presiune.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-730">
            <div className="bg-gold/10 border border-gold/30 rounded-[20px] p-6 flex items-start gap-4" data-id="element-731">
              <Clock className="w-8 h-8 text-gold-dark shrink-0" data-id="element-732" />
              <div data-id="element-733">
                <p className="text-charcoal/80 text-[18px] leading-relaxed" data-id="element-734">
                  Grupul este limitat intenționat, ca să păstrez calitatea și
                  profunzimea procesului. Locurile se alocă în ordinea
                  aplicării.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}